// Mock data for Constantinou Bros Athena Beach Hotel travel blog

export const mockHotelData = {
  hotel: {
    name: "Constantinou Bros Athena Beach Hotel",
    rating: 4,
    destination: "Paphos, Cyprus",
    checkIn: "2 Aug 2025",
    checkOut: "9 Aug 2025",
    duration: "7 nights",
    heroImage: "https://images.unsplash.com/photo-1708881669601-6c145c1ae26a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxDeXBydXMlMjBiZWFjaCUyMGhvdGVsfGVufDB8fHx8MTc1MzgyNjY1MHww&ixlib=rb-4.1.0&q=85"
  },
  weather: {
    location: "Paphos, Cyprus",
    period: "2-9 August 2025",
    averageTemp: "32°C",
    description: "Perfect Mediterranean weather with sunny skies and gentle sea breezes",
    dailyForecast: [
      { date: "Aug 2", temp: "31°C", condition: "Sunny", icon: "☀️" },
      { date: "Aug 3", temp: "33°C", condition: "Partly Cloudy", icon: "⛅" },
      { date: "Aug 4", temp: "32°C", condition: "Sunny", icon: "☀️" },
      { date: "Aug 5", temp: "34°C", condition: "Sunny", icon: "☀️" },
      { date: "Aug 6", temp: "31°C", condition: "Partly Cloudy", icon: "⛅" },
      { date: "Aug 7", temp: "33°C", condition: "Sunny", icon: "☀️" },
      { date: "Aug 8", temp: "32°C", condition: "Sunny", icon: "☀️" },
      { date: "Aug 9", temp: "30°C", condition: "Sunny", icon: "☀️" }
    ],
    weatherImage: "https://images.unsplash.com/photo-1601658480525-0d3cf704ca48?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxNZWRpdGVycmFuZWFuJTIwdmFjYXRpb258ZW58MHx8fHwxNzUzODI2NjU2fDA&ixlib=rb-4.1.0&q=85"
  },
  programs: {
    title: "Hotel Programs & Activities",
    activities: [
      {
        name: "Morning Aqua Aerobics",
        time: "10:00 AM",
        description: "Start your day with energizing water exercises in the main pool",
        category: "Fitness"
      },
      {
        name: "Greek Cooking Class",
        time: "2:00 PM",
        description: "Learn to make traditional Cypriot dishes with our head chef",
        category: "Cultural"
      },
      {
        name: "Live Music at Sunset Bar",
        time: "7:00 PM",
        description: "Enjoy cocktails and live acoustic performances as the sun sets",
        category: "Entertainment"
      },
      {
        name: "Kids Animation Club",
        time: "4:00 PM",
        description: "Fun activities and games for children supervised by trained staff",
        category: "Kids"
      },
      {
        name: "Beach Volleyball Tournament",
        time: "11:00 AM",
        description: "Join our weekly beach volleyball competition with prizes",
        category: "Sports"
      },
      {
        name: "Wine Tasting Evening",
        time: "8:00 PM",
        description: "Sample local Cypriot wines paired with Mediterranean appetizers",
        category: "Culinary"
      }
    ],
    amenities: [
      "3 Swimming pools including infinity pool",
      "Private beach access",
      "Full-service spa",
      "Tennis court",
      "Fitness center",
      "Kids' playground",
      "Multiple restaurants and bars",
      "Free Wi-Fi throughout"
    ],
    programImage: "https://images.unsplash.com/photo-1534338332682-8c9735c0a2f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxNZWRpdGVycmFuZWFuJTIwdmFjYXRpb258ZW58MHx8fHwxNzUzODI2NjU2fDA&ixlib=rb-4.1.0&q=85"
  },
  tours: {
    title: "Local Tours & Excursions",
    tours: [
      {
        name: "Paphos Archaeological Park",
        duration: "3 hours",
        price: "€25 per person",
        description: "Explore ancient Roman villas with stunning mosaic floors and historical ruins",
        highlights: ["UNESCO World Heritage Site", "Roman mosaics", "Ancient amphitheater"],
        image: "https://images.unsplash.com/photo-1601658480117-2b096ed317ce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxNZWRpdGVycmFuZWFuJTIwdmFjYXRpb258ZW58MHx8fHwxNzUzODI2NjU2fDA&ixlib=rb-4.1.0&q=85"
      },
      {
        name: "Akamas Peninsula Safari",
        duration: "Full day",
        price: "€65 per person",
        description: "Adventure through Cyprus' last wilderness area with 4x4 vehicles",
        highlights: ["Lara Bay turtle nesting", "Blue Lagoon", "Unspoiled nature"],
        image: "https://images.unsplash.com/photo-1601658479746-0eb22941b9b9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHw0fHxNZWRpdGVycmFuZWFuJTIwdmFjYXRpb258ZW58MHx8fHwxNzUzODI2NjU2fDA&ixlib=rb-4.1.0&q=85"
      },
      {
        name: "Troodos Mountains Wine Tour",
        duration: "6 hours",
        price: "€45 per person",
        description: "Visit traditional wineries in the cool mountain villages",
        highlights: ["Local wine tasting", "Mountain villages", "Traditional lunch"],
        image: "https://images.unsplash.com/photo-1602523499042-4d9e151fcf94?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxDeXBydXMlMjBiZWFjaCUyMGhvdGVsfGVufDB8fHx8MTc1MzgyNjY1MHww&ixlib=rb-4.1.0&q=85"
      },
      {
        name: "Coral Bay Beach Hopping",
        duration: "4 hours",
        price: "€35 per person",
        description: "Discover the most beautiful beaches around Paphos",
        highlights: ["Crystal clear waters", "Snorkeling spots", "Beach tavernas"],
        image: "https://images.unsplash.com/photo-1589475779939-279faf783211?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxDeXBydXMlMjBiZWFjaCUyMGhvdGVsfGVufDB8fHx8MTc1MzgyNjY1MHww&ixlib=rb-4.1.0&q=85"
      }
    ]
  },
  personalReview: {
    title: "Our Family Experience",
    rating: 5,
    review: "What an absolutely wonderful week we had at Constantinou Bros Athena Beach Hotel! The location right on the beach was perfect for our family, and the kids loved the pools. The staff were incredibly friendly and helpful throughout our stay. The food was delicious with great variety, and the evening entertainment kept us all engaged. We're already planning our return trip!",
    highlights: [
      "Exceptional service from all staff members",
      "Perfect location right on the beach",
      "Excellent food variety and quality",
      "Great entertainment and activities for all ages",
      "Beautiful, well-maintained facilities"
    ],
    familyTips: [
      "Book the Greek cooking class early - it fills up quickly!",
      "The infinity pool is less crowded in the mornings",
      "Ask for a room with sea view - it's worth the upgrade",
      "The kids' club is excellent for some adult relaxation time",
      "Don't miss the sunset from the beach bar"
    ]
  }
};